import { useState } from "react";
import { toast } from "sonner";
import { Save, ShieldCheck, Trash2, Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/dashboard/ui";

const inputCls = "mt-1.5 w-full bg-secondary border border-input rounded-xl px-4 py-3 text-white outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors";

export default function Settings() {
  const { user, refresh } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", business_name: user?.business_name || "", phone: user?.phone || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try { await api.patch("/profile", f); await refresh(); toast.success("Profile updated"); }
    catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader title="Settings" subtitle="Manage your studio profile and data." />

      <div className="rounded-2xl border border-border bg-black/40 p-6">
        <h3 className="text-white font-medium mb-5">Studio profile</h3>
        <div className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="text-sm text-secondary-foreground">Your name</label><input data-testid="settings-name" value={f.name} onChange={set("name")} className={inputCls} /></div>
            <div><label className="text-sm text-secondary-foreground">Studio name</label><input data-testid="settings-business" value={f.business_name} onChange={set("business_name")} className={inputCls} /></div>
          </div>
          <div><label className="text-sm text-secondary-foreground">Email</label><input value={user?.email || ""} disabled className={`${inputCls} opacity-60 cursor-not-allowed`} /></div>
          <div><label className="text-sm text-secondary-foreground">Phone</label><input data-testid="settings-phone" value={f.phone} onChange={set("phone")} className={inputCls} /></div>
        </div>
        <button data-testid="settings-save" onClick={save} disabled={saving} className="mt-6 inline-flex items-center gap-2 bg-gold text-black font-medium rounded-full px-6 py-2.5 hover:bg-gold-light transition-colors disabled:opacity-60">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save changes
        </button>
      </div>

      <div className="rounded-2xl border border-border bg-black/40 p-6 mt-5">
        <div className="flex items-center gap-2 mb-3"><ShieldCheck className="w-5 h-5 text-gold" /><h3 className="text-white font-medium">Privacy & face data</h3></div>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Face embeddings are stored securely and never exposed publicly. Guests give consent before any selfie is processed.
          You can permanently delete all face data for an event from that event's page at any time.
        </p>
        <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground"><Trash2 className="w-3.5 h-3.5" /> Face-data deletion is available per event.</div>
      </div>
    </div>
  );
}
